<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab title="المناقشة">
              <app-timeline>
                <app-timeline-item v-for="item in items" :key="item.id" :title="$t(`master.` + item.key)"
                  :subtitle="variant(item) ? 'في انتظار الموافقة ' : 'موافقة '" :time="moment(item.updated_at).fromNow()"
                  :variant="variant(item) ? 'danger' : 'success'" />
              </app-timeline>
              <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <form-wizard color="#80b02c" :subtitle="null" :title="null" :finish-button-text="$t('site.finish')"
                :back-button-text="$t('site.back')" :next-button-text="$t('site.next')" @on-complete="formSubmitted"
                :start-index="tab" step-size="sm" ref="wizard">
                <b-card>
                  <!-- attach_master_file -->

                  <!-- <tab-content
                    title="تعديل البحث "
                    :before-change="
                      () => validateStep('general_idea_of_the_topic')
                    "
                  >
                    <upload-vue
                      ref="general_idea_of_the_topic"
                      datakey="general_idea_of_the_topic"
                      :files="referral_for_grammar_and_spelling_check"
                          :master="masterId"
                    />
                  </tab-content> -->
                  <tab-content title="الأطروحة ">
                    <upload-vue ref="thesis" datakey="thesis" :files="thesis" :master="masterId" />
                  </tab-content>
                  <!-- <tab-content
                    title="إعتماد الإدارة العلمية"
                    :before-change="() => validateStep('research_field')"
                  >
                    <upload-vue ref="research_field" datakey="research_field" :files="suggested_title"
                          :master="masterId"/>
                  </tab-content>
                  <tab-content
                    title="إفادة مقيم لغوي "
                    :before-change="() => validateStep('research_field')"
                  >
                    <upload-vue ref="research_field" datakey="research_field" :files="suggested_title"
                          :master="masterId"/>
                  </tab-content>
                  <tab-content
                    title="تشكيل لجنة المناقشة"
                    :before-change="() => validateStep('research_field')"
                  >
                    <upload-vue ref="research_field" datakey="research_field" :files="suggested_title"
                          :master="masterId" />
                  </tab-content> -->

                </b-card>
              </form-wizard>
            </b-tab>
          </b-tabs>
        </div>
        <br />
        <!-- <div class="card-footer text-muted">
          <div class="row">
            <div class="col-sm-2">موافقة القسم</div>
            <div class="col-sm-4">
              <b-badge variant="light-danger"> في انتظار الموافقة </b-badge>
            </div>
            <div class="col-sm-2">موافقة الكلية</div>
            <div class="col-sm-4">
              <b-badge variant="light-danger"> في انتظار الموافقة </b-badge>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">تاريخ الموافقة</div>
            <div class="col-sm-4">
              <b-badge variant="light-danger"> - </b-badge>
            </div>
            <div class="col-sm-2">تاريخ الموافقة</div>
            <div class="col-sm-4">
              <b-badge variant="light-danger"> - </b-badge>
            </div>
          </div>
        </div> -->
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import uploadVue from "./wizard/upload.vue";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";
import Auth from "@/Apis/Auth";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import MastersDataController from "@/Controllers/MastersDataController";
import SettingController from '@/Controllers/SettingController';
import MastersController from '@/Controllers/MastersController';
// Department
export default {
  components: {
    FormWizard,
    TabContent,
    uploadVue,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      tab: 0,
      items: [],
      load: true,
      masterId: Auth.MASTER.id,
      thesis: []
    };
  },
  async created() {
    this.time = await new SettingController().time();

    const timeLine = new MastersController().timeLine();
    const key = timeLine
      .find((a) => a.code == "discussion")
      .phases.map((a) => {
        return a.code;
      });

    const res = await new MasterKeyStatusController().GetAll({
      filter: "master_id|" + this.masterId,
      filterIn: "key|" + key.toString(),
      with: ["mastersData"],
    });

    console.log(res);
    this.items = res;
    this.load = false;
    this.thesis = this.getData(
      "thesis",
      1,
      true
    );
  },
  methods: {
    setTab(res, key) {
      const find = res.find((a) => a.key == key);
      if (find) return true;
      return false;
    },
    variant(item) {
      return item.value == null || item.value == "" || item.value == "-1";
    },
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      console.log(refToValidate);
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return false;

      return true;
    },
    async formSubmitted() {
      this.$router.push({ name: "Thesis" });
    },
  },
};
</script>

<style></style>